var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 18.9653L14.7455 13.7733C15.9932 12.2755 16.6154 10.3543 16.4826 8.40936C16.3499 6.46447 15.4724 4.64563 14.0328 3.33122C12.5931 2.01681 10.7022 1.30802 8.75327 1.3523C6.80436 1.39658 4.94754 2.19053 3.5691 3.56897C2.19065 4.94742 1.3967 6.80423 1.35242 8.75315C1.30814 10.7021 2.01693 12.593 3.33134 14.0327C4.64575 15.4723 6.46459 16.3498 8.40948 16.4825C10.3544 16.6153 12.2756 15.9931 13.7734 14.7454L18.9654 19.9374L19.9375 18.9653ZM2.75005 8.93743C2.75005 7.71365 3.11294 6.51737 3.79283 5.49984C4.47272 4.48231 5.43908 3.68924 6.5697 3.22092C7.70031 2.75261 8.94441 2.63007 10.1447 2.86882C11.3449 3.10756 12.4474 3.69687 13.3128 4.5622C14.1781 5.42754 14.7674 6.53005 15.0062 7.73031C15.2449 8.93056 15.1224 10.1747 14.6541 11.3053C14.1857 12.4359 13.3927 13.4023 12.3751 14.0821C11.3576 14.762 10.1613 15.1249 8.93755 15.1249C7.29708 15.1231 5.72432 14.4706 4.56434 13.3106C3.40435 12.1507 2.75187 10.5779 2.75005 8.93743Z",
    fill: "#737D86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchs);
export default __webpack_public_path__ + "static/media/iconSearchs.d9df76be6f49306db126a4e5cbc5c569.svg";
export { ForwardRef as ReactComponent };